import React from "react";
import { menuItemsList } from "./menuItemsList";
import MenuItems from './MenuItems';


function Navbar({
  autenticazione,
  temaColori,
  mobile
}) {

    return(
        <nav>   
        {/* desktop */}
        {!mobile && <ul className="menus flex">
          {menuItemsList.map((menu, index) => {
           const depthLevel = 0;
           return <MenuItems autenticazione={autenticazione} items={menu} key={index} depthLevel={depthLevel} temaColori={temaColori}/>;
          })}
        </ul>}
        {/* mobile */}
        {mobile && <ul className="menus flex">
          {menuItemsList.map((menu, index) => {
           const depthLevel = 0;
           if (menu.mobile) {
            return <MenuItems autenticazione={autenticazione} items={menu} key={index} depthLevel={depthLevel} temaColori={temaColori}/>
           }
           return null;
          })}
        </ul>}
      </nav>
    
    )
}

export default Navbar;
